<script>
import StarRating from "@/components/reviews/StarRating.vue";
import ModalReviewsDelete from "@/components/reviews/modals/ModalsReviewsDelete.vue";
import ModalReviewUpdate from "@/components/reviews/modals/ModalReviewUpdate.vue";

export default {
  name: 'DetailsReview',
  components: {ModalReviewUpdate, ModalReviewsDelete, StarRating},
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewModalDelete: false,
      viewModalUpdate: false
    }
  }
}
</script>

<template>
  <div v-if="review.products" class="grid md:grid-cols-12 gap-4 md:gap-6 pb-4 md:pb-6">
    <modal-review-update v-if="viewModalUpdate" :review="review" @close-modal="viewModalUpdate = false" />
    <modal-reviews-delete v-if="viewModalDelete" :id="review.id" @close-modal="viewModalDelete=false" />
    <dl class="md:col-span-3 order-3 md:order-1">
      <dt class="sr-only">Product:</dt>
      <dd class="text-base font-semibold text-gray-900 dark:text-white">
        <a :href="`/boutique/${review.products.tag}`" target="_blank" class="hover:underline">
          {{ review.products.title }} - {{ review.products.category.Label }}
        </a>
      </dd>
    </dl>

    <dl class="md:col-span-6 order-4 md:order-2">
      <dt class="sr-only">Message:</dt>
      <dd class=" text-gray-500 dark:text-gray-400">
        {{ review.Text }}
      </dd>
    </dl>

    <div class="md:col-span-3 content-center order-1 md:order-3 flex items-center justify-between">
      <dl>
        <dt class="sr-only">Note:</dt>
        <star-rating :note="review.note" />
      </dl>
      <div class=" ml-12 sm:grid-cols-2 flex lg:w-64 lg:items-center lg:justify-end gap-4">
        <button @click="viewModalUpdate = true" class="w-full rounded-lg px-3 py-2 text-center text-sm font-medium text-white bg-primary-700 hover:bg-primary-800 lg:w-auto">
          Modifier
        </button>
        <button @click="viewModalDelete = true" class="w-full inline-flex justify-center rounded-lg bg-red-600 px-3 py-2 text-sm font-medium text-white hover:bg-red-700 lg:w-auto">
          Supprimer
        </button>
      </div>
    </div>
  </div>
  <modal-reviews-delete v-if="viewModalDelete" :id="review.id" @close-modal="viewModalDelete=false" />
  <modal-review-update v-if="viewModalUpdate" :review="review" @close-modal="viewModalUpdate = false" />
</template>
